<template>
  <div class="flex flex-col gap-6 mt-5">
    <div class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]"
        >Add a prompt to guide the Voice Agent</span
      >
      <a-textarea
        v-model:value="modelValue.instruction"
        class="textarea_large"
        :rows="4"
        placeholder="Enter prompt"
      />
    </div>

    <div class="flex flex-col gap-2">
      <span class="secondary_color text-[13px]">Voice</span>
      <a-select
        v-model:value="localVoiceAgentId"
        placeholder="Select voice agent"
      >
        <template #suffixIcon>
          <ThemeImage
            :icon="imageNames.BOTTOM_ARROW"
            alt="bottom_white_arrow"
            class="size-4"
          />
        </template>

        <a-select-option
          v-for="(agent, index) in voiceAgents"
          :key="`${agent?.id}_${index}`"
          :value="agent?.id"
        >
          <div class="flex flex-row items-center gap-2">
            <ThemeImage
              class="size-4"
              :icon="imageNames.VOICE_AGENT_PLAY"
              alt="voice_agent_play"
            />
            {{ agent?.text }}
          </div>
        </a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { voiceAgents } from "@/src/constants/callConstants.js";
import { imageNames } from "@/src/constants/imageConstants.js";

const props = defineProps({
  modelValue: { type: Object, required: true },
});

const localVoiceAgentId = ref(null);

const initLocalValues = () => {
  if (props.modelValue.metadata) {
    localVoiceAgentId.value = props.modelValue.metadata.voice_agent_id || null;
  } else {
    localVoiceAgentId.value = null;
  }
};

const updateMetadata = () => {
  if (!props.modelValue.metadata) {
    props.modelValue.metadata = {};
  }
  props.modelValue.metadata.voice_agent_id = localVoiceAgentId.value;
};

watch(() => props.modelValue.metadata, initLocalValues, { immediate: true });

watch(localVoiceAgentId, updateMetadata);

watch(
  () => props.modelValue.step_type,
  (newVal) => {
    if (newVal === "" || newVal !== "VOICE") {
      localVoiceAgentId.value = null;
    }
  },
);
</script>
